import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";
import { supabase } from "../supabaseClient";
import { images } from "../config/images";
import { FaUserCircle, FaSearch, FaTimes } from "react-icons/fa";
import UserProfileCard from "../components/UserProfileCard";

export default function Header({
  onLoginClick,
  onLogout,
  session,
  profile: externalProfile,
  onProfileUpdate,
  hasOverdueToday = false,
  showGlow = true,
  onGlowDismiss,
  // ── modo Cards ──────────────────────────────
  modoCards = false,
  projectName = "",
  onSearch,
}) {
  const navigate = useNavigate();

  const [showProfileCard, setShowProfileCard] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchFocused, setSearchFocused] = useState(false);

  // Auto-open profile card if incomplete
  useEffect(() => {
    if (externalProfile && (!externalProfile.nome || !externalProfile.empresa || !externalProfile.funcao || !externalProfile.container)) {
      setShowProfileCard(true);
    }
  }, [externalProfile]);

  const handleLogout = async () => { 
    await supabase.auth.signOut(); 
    onLogout?.(); 
    navigate("/"); 
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    onSearch?.(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    onSearch?.("");
  };

  const avatarUrl = externalProfile?.avatar_url || null;
  const avatarWrapperClass = `header-avatar-wrapper ${showGlow ? (hasOverdueToday ? "overdue-glow" : "on-time-glow") : ""}`;
  
  const handleAvatarClick = () => { 
    setShowProfileCard(true); 
    if (showGlow && onGlowDismiss) onGlowDismiss(); 
  };

  const firstName = externalProfile?.nome ? externalProfile.nome.split(" ")[0] : "Usuário";

  // ════════════════════════════════════════════════════════════
  //  MODO CARDS — top bar minimalista
  // ════════════════════════════════════════════════════════════
  if (modoCards) {
    return (
      <>
        <header className="header header--cards">
          {/* Esquerda: nome do projeto */}
          <div className="hc__project-name">
            {projectName || "Projeto"}
          </div>

          {/* Centro: busca */}
          <div className={`hc__search${searchFocused ? " hc__search--focused" : ""}`}>
            <FaSearch size={12} className="hc__search-icon" />
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              onFocus={() => setSearchFocused(true)}
              onBlur={() => setSearchFocused(false)}
              placeholder="Buscar notas..."
              className="hc__search-input"
            />
            {searchTerm && (
              <button className="hc__search-clear" onClick={handleClearSearch}>
                <FaTimes size={10} />
              </button>
            )}
          </div>

          {/* Direita: avatar + nome */}
          <div className="hc__user">
            <div className={avatarWrapperClass} onClick={handleAvatarClick} style={{ cursor: "pointer" }}>
              {avatarUrl 
                ? <img src={avatarUrl} alt="Avatar" className="header-avatar" /> 
                : <FaUserCircle className="header-avatar-placeholder" />
              }
            </div>
            <span className="hc__user-name" onClick={handleAvatarClick} style={{ cursor: "pointer" }}>
              {firstName}
            </span>
          </div>
        </header>

        {/* UserProfileCard */}
        {showProfileCard && (
          <UserProfileCard
            userId={session?.user?.id}
            userEmail={session?.user?.email}
            profile={externalProfile}
            onProfileUpdate={onProfileUpdate}
            onLogout={handleLogout}
            onClose={() => setShowProfileCard(false)}
          />
        )}
      </>
    );
  }

  // ════════════════════════════════════════════════════════════
  //  MODO NORMAL — header original
  // ════════════════════════════════════════════════════════════
  return (
    <>
      <header className="header">
        <div className="header-left" onClick={() => navigate("/")}>
          <img src={images.ob2} alt="Logo" />
        </div>

        <div className="header-right">
          {session ? (
            <div className="header-user-info">
              <div className={avatarWrapperClass} onClick={handleAvatarClick} style={{ cursor: "pointer" }}>
                {avatarUrl 
                  ? <img src={avatarUrl} alt="Avatar" className="header-avatar" /> 
                  : <FaUserCircle className="header-avatar-placeholder" />
                }
              </div>
              <p className="header-welcome" onClick={handleAvatarClick} style={{ cursor: "pointer" }}>
                Bem-vindo, <strong>{externalProfile?.nome ? externalProfile.nome.split(" ").slice(0, 2).join(" ") : "Usuário"}</strong>
              </p>
            </div>
          ) : (
            <button className="header-btn-login" onClick={onLoginClick}>Entrar</button>
          )}
        </div>
      </header>

      {/* UserProfileCard */}
      {showProfileCard && (
        <UserProfileCard
          userId={session?.user?.id}
          userEmail={session?.user?.email}
          profile={externalProfile}
          onProfileUpdate={onProfileUpdate}
          onLogout={handleLogout}
          onClose={() => setShowProfileCard(false)}
        />
      )}
    </>
  );
}